<template>
  <DialogContainer
    :showDialog="showDialog"
    title="Add Client"
    icon="add"
    :toolbarActions="[
      {
        text: 'Save',
        icon: 'save',
        buttonColor: 'success',
        emitEvent: 'onSubmitClicked',
        showIsLoading: true,
        isDisabledFunc: () => !isFormValid,
      },
      {
        text: 'Cancel',
        depressed: true,
        emitEvent: 'onCancelClicked',
      },
    ]"
    @onCancelClicked="onCancelClicked"
    @onSubmitClicked="onSubmitClicked"
    :isLoading="isLoading"
  >
    <v-container pa-0 grid-list-lg>
      <v-form v-model="isFormValid" ref="form">
        <v-layout wrap>
          <v-flex xs12>
            <ControlTextField
              label="Client Name*"
              autofocus
              v-model="name"
              :disabled="isLoading"
              :rules="[(v) => !!v || 'Required']"
            />
          </v-flex>
        </v-layout>
        <small>*indicates required field</small>
      </v-form>
    </v-container>
  </DialogContainer>
</template>

<script>
import DialogContainer from '../../../common/components/layouts/DialogContainer'
import ControlTextField from '../../../common/components/controls/ControlTextField'

export default {
  components: {
    DialogContainer,
    ControlTextField,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isFormValid: false,
    name: null,
  }),
  watch: {
    showDialog() {
      if (!this.showDialog) {
        this.clearDialog()
      }
    },
  },
  methods: {
    onSubmitClicked() {
      this.$emit('onSubmitClicked', {
        name: this.name,
      })
    },
    onCancelClicked() {
      this.$emit('onCancelClicked')
    },
    clearDialog() {
      this.$refs.form.reset()
      this.name = null
    },
  },
}
</script>